import { Agreement, AgreementVerifyResult, ChainStatus, PublicVerifyResult, SignedUrlResponse, page } from '@cloudsign/shared';
import type { AgreementStatus } from '@cloudsign/shared';
import { t } from '../../lib/i18n';

export { Agreement, AgreementVerifyResult, ChainStatus, PublicVerifyResult, SignedUrlResponse };
export const AgreementPage = page(Agreement);

export const BASE = '/agreements';
export const PAGE_SIZE = 20;
export const STATUSES: AgreementStatus[] = ['pending', 'sealed', 'failed', 'redacted'];
export const MAX_PDF_BYTES = 10 * 1024 * 1024;

export const keys = {
  list: (q: Record<string, unknown>) => ['agreements', 'list', q] as const,
  chain: ['agreements', 'chain'] as const,
  visit: (visitId: string) => ['agreements', 'list', { visitId }] as const,
};

export const statusLabel = (s: AgreementStatus): string => t(`agreementsUi.status.${s}`);
export const statusTone = (s: AgreementStatus): 'neutral' | 'good' | 'warn' | 'bad' =>
  s === 'sealed' ? 'good' : s === 'failed' ? 'bad' : s === 'pending' ? 'warn' : 'neutral';
